"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var StartEvent = {
  parent: null,
  name: 'start'
},
    StopEvent = {
  parent: null,
  name: 'stop'
};
exports.StartEvent = StartEvent;
exports.StopEvent = StopEvent;